/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_AlphaInputs */

const en_gc_editor_alpha = /** @type {(inputs: Gc_Editor_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft is alpha software. Keep backups of important files. The desktop app is recommended for regular work.`)
};

const zh_gc_editor_alpha = /** @type {(inputs: Gc_Editor_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 目前为 Alpha 版本，请备份重要文件。日常工作推荐使用桌面版。`)
};

/**
* | output |
* | --- |
* | "GridCraft is alpha software. Keep backups of important files. The desktop app is recommended for regular work." |
*
* @param {Gc_Editor_AlphaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_alpha = /** @type {((inputs?: Gc_Editor_AlphaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_AlphaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_alpha(inputs)
	return zh_gc_editor_alpha(inputs)
});
export { gc_editor_alpha as "gc.editor.alpha" }